<template>
  <div id="Player">
    <div id="me">{{ userName }}</div>
    <div id="messages" class="notranslate" v-if="msg">
      {{ msg }}
    </div>
    <div
      v-if="
        state.initial &&
        participants[userName] &&
        participants[userName].winner == 1
      "
    >
      <img class="trophy" src="../assets/trophy.svg" alt="" />
    </div>

    <div id="Title">
      <div v-if="state.initial">My Feedback Score</div>
      <div v-else-if="state.selectParticipantAndQuestion">Feedback geben</div>
      <div v-else-if="state.selectAnswer">Feedback</div>
      <div v-else-if="state.review || state.reviewSingle">Mein Feedback</div>
      <div v-else>My Feedback Score</div>
    </div>
    <div id="SubTitle" class="subsmaller notranslate">
      <div class="notranslate" v-if="state.selectParticipantAndQuestion">
        ... an Teilnehmer_in
      </div>
      <div class="notranslate" v-else-if="state.selectAnswer">
        an TN {{ participantSelected }} auf Übung {{ questionSelected }}
      </div>
      <div v-else-if="state.review" class="reviewSubtitel notranslate">
        <div class="notranslate">auf Übung</div>
        <div class="notranslate">von TN</div>
      </div>
      <div class="notranslate" v-else-if="state.reviewSingle">
        von TN {{ selectedForReview.f }} auf Übung {{ selectedForReview.u }}
      </div>
    </div>
    <div v-if="state.reviewSingle" class="abstand"></div>
    <div v-if="state.initial" id="score">
      {{ scoreFilter() }}
    </div>

    <div
      id="middleText"
      v-if="(state.initial && score == 0) || state.selectParticipantAndQuestion"
    >
      <div class="welcomeText notranslate" v-if="state.initial && score == 0">
        <div>Willkommen {{ userNameAlt }}</div>
      </div>
      <div id="ParticipantHolder" v-if="state.selectParticipantAndQuestion">
        <div
          class="participant notranslate"
          v-for="(p, index) in participants"
          :key="p"
          @click="selectParticipant(index)"
          :class="[participantSelected == index ? 'selected' : '']"
        >
          <template v-if="p.nameAlt">
            {{ p.nameAlt }}
          </template>
          <template v-else>
            {{ index }}
          </template>
        </div>
      </div>
    </div>
    <template v-if="state.initial && score > 0">
      <Balken :me="participants[userName]" :uebungen="uebungen" />
    </template>
    <template v-if="state.selectAnswer" class="questions">
      <Question
        ref="Questions"
        :fragen="questions"
        :uebung="questionSelected"
        @answer="answerChange"
      />
    </template>
    <template v-if="state.review">
      <Review
        ref="Review"
        :me="participants[userName]"
        @review="updateReview"
      />
    </template>
    <template v-if="state.reviewSingle">
      <Question
        :me="participants[userName]"
        :fragen="questions"
        :uebung="selectedForReview.u"
        :nutzer="selectedForReview.f"
        :reviewMode="true"
      />
    </template>

    <div id="AtoD" v-if="state.selectParticipantAndQuestion">
      <div class="subsmaller aufUebung notranslate pointer">... auf Übung</div>
      <button
        v-for="u in uebungen"
        :key="u"
        @click="selectQuestion(u)"
        :class="[questionSelected == u ? 'selected' : '']"
        class="notranslate"
      >
        {{ u }}
      </button>
    </div>

    <div id="feedbackHolder">
      <div id="topHolder" v-if="!state.reviewSingle && !state.review">
        <div
          class="feedback giveFeedback notranslate pointer"
          @click="clickTopButton"
          :class="[answers_given >= 3 ? 'white' : '']"
        >
          <div
            class="notranslate"
            v-if="state.initial || state.selectParticipantAndQuestion"
          >
            give feedback
          </div>
          <div class="notranslate" v-else-if="state.selectAnswers">
            send feedback
          </div>
          <div class="notranslate" v-else-if="answers_given >= 3">
            send feedback
          </div>
          <div class="notranslate" v-else-if="waitingFlag">please wait...</div>
          <div class="notranslate" v-else-if="state.review"></div>
          <div class="notranslate" v-else>give feedback</div>
        </div>
        <div ref="progressBar" id="topColor" class="topColor"></div>
        <div
          id="topColorWhite"
          class="borderRadiusLeft topColor"
          :style="
            'left: ' +
            progressBarRight +
            'px; width:calc(100% - ' +
            progressBarRight +
            'px)'
          "
        ></div>
      </div>
      <div
        class="feedback feedbackBottom notranslate pointer"
        @click="clickBottomButton"
      >
        <template v-if="state.initial"> see my feedback </template>
        <template v-else>go back</template>
      </div>
    </div>
    <!-- <div id="feedbackHolder">
      <div id="topHolder" v-if="!state.reviewSingle && !state.review">
        <div class="feedback giveFeedback" @click="clickTopButton">
          <div v-if="state.initial || state.selectParticipantAndQuestion">
            give feedback
          </div>
          <div v-else-if="state.selectAnswers">send feedback</div>
          <div v-else-if="answers_given >= 3">send feedback</div>
          <div v-else-if="waitingFlag">please wait...</div>
          <div v-else-if="state.review"></div>
          <div v-else>give feedback</div>
        </div>
      </div>
      <div class="feedback feedbackBottom" @click="clickBottomButton">
        <template v-if="state.initial"> see my feedback </template>
        <template v-else>go back</template>
      </div>
    </div> -->

    <div class="not_supported">Sorry - you need a bigger screen to play!</div>
  </div>
</template>

<script>
import DeviceDetector from "device-detector-js";
import Question from "./Question.vue";
import Review from "./Review.vue";
import Balken from "./Balken.vue";

import confetti from "canvas-confetti";

export default {
  name: "Player",
  components: { Question, Review, Balken },
  data() {
    return {
      token: this.$route.query.token,
      userName: "",
      userNameAlt: "",
      msg: "",
      msgTimer: null,
      score: 0,
      currentEntry: -1,
      participants: {},
      state: {
        initial: true,
        selectParticipantAndQuestion: false,
        selectAnswer: false,
        readyToSend: false,
        review: false,
        reviewSingle: false,
      },
      uebungen: ["A", "B", "C", "D"],
      questionSelected: "",
      participantSelected: "",
      deviceDetector: {},
      device: {},
      questions: [],
      progressBarRight: 0,
      progressBarRightInitial: 0,
      animationInterval: {},
      animationIntervalRunning: false,
      animationValueBefore: 0,
      animationValueAfter: 0,
      answers_given: 0,
      answers: new Array(3).fill(0),
      waitingFlagTimer: {},
      waitingFlag: false,
      selectedForReview: {
        u: "",
        f: "",
      },
      confettiInterval: {},
      confettiPlayed: false,
    };
  },
  watch: {
    participants: function (newV) {
      this.score = this.calcScore(newV);
    },
  },

  methods: {
    createConfetti() {
      if (this.confettiPlayed) return;
      var count = 200;
      var y = 1;

      function fire(particleRatio, opts, x) {
        confetti(
          Object.assign(
            {},
            {
              origin: { y: y, x: x },
            },
            opts,
            {
              particleCount: Math.floor(count * particleRatio),
            }
          )
        );
      }
      let x = 0.2;
      let pass = 1;
      console.log("yes2");

      this.confettiInterval = setInterval(() => {
        console.log("yes");
        if (x >= 1) {
          if (pass == 2) {
            clearInterval(this.confettiInterval);
            return;
          }
          y = 0.75;
          x = 0.2;
          pass = 2;
        }
        fire(
          0.25,
          {
            spread: 26,
            startVelocity: 55,
          },
          x
        );
        fire(
          0.2,
          {
            spread: 60,
          },
          x
        );
        fire(
          0.35,
          {
            spread: 100,
            decay: 0.91,
            scalar: 0.8,
          },
          x
        );
        fire(
          0.1,
          {
            spread: 120,
            startVelocity: 25,
            decay: 0.92,
            scalar: 1.2,
          },
          x
        );
        fire(
          0.1,
          {
            spread: 120,
            startVelocity: 45,
          },
          x
        );
        x += 0.3;
      }, 300);

      this.confettiPlayed = true;
    },
    updateReview(selected) {
      this.selectedForReview = selected;

      if (!(this.selectedForReview.u && this.selectedForReview.f)) {
        this.setMessage("please select feedback");
        return;
      }
      this.newState("reviewSingle");
    },
    lerp(a, b, p) {
      return a + p * (b - a);
    },
    spring_wobbly(t) {
      let a = 0;
      return (
        -0.5 *
        2.71828 ** (-6 * (t - a)) *
        (-2 * 2.71828 ** (6 * (t - a)) + 2 * Math.cos(15 * (t - a)))
      );
    },
    resetBar() {
      this.answers = new Array(3).fill(0);
      this.progressBarRightInitial = 0;
      this.animationValueAfter = 0;
      this.progressBarRight = 0;
      this.answers_given = 0;
      if (this.animationIntervalRunning) {
        this.animationIntervalRunning = false;
        clearInterval(this.animationInterval);
      }
      console.log("Bar reset");
    },
    animateProgressBar(n, anzahl) {
      if (!anzahl) anzahl = 1;
      let endwert = 9.988; //woher kommt das
      endwert = 10;
      let stepsForFullBar = 5;
      let scaling = this.$refs.progressBar.clientWidth / stepsForFullBar;
      // console.log(scaling);
      // n = +1 or -1
      var breaker = 100;
      var currentStep = 0;
      var duration = 1; // in seconds
      var steps = 100;
      // console.log("in0");

      //animation is not finished and was interrupted!
      if (this.animationIntervalRunning) {
        // console.log("inIn0");
        this.progressBarRightInitial = this.animationValueAfter;
        this.progressBarRight = this.progressBarRightInitial;
        // console.log("interrup new initial: " + this.progressBarRightInitial);
        this.animationIntervalRunning = false;
        clearInterval(this.animationInterval);
      }

      // console.log("in1");
      //state will be this when finished
      //find end value
      for (var i = 0; i < breaker; i++) {
        let t = i / 100;
        let p = this.spring_wobbly(t);
        this.animationValueAfter =
          this.progressBarRightInitial +
          ((scaling / endwert) *
            (n * Math.round(this.lerp(0, 10 * anzahl, p) * 10000))) /
            10000;
      }

      // console.log("n: " + n);
      // console.log("Init0: " + this.progressBarRightInitial);
      // console.log("End0: " + this.animationValueAfter);

      if (this.animationIntervalRunning) return;
      // console.log("in2");
      this.animationInterval = setInterval(() => {
        // console.log("inside interval");
        this.animationIntervalRunning = true;
        if (currentStep >= breaker) {
          //stop the interval
          this.progressBarRightInitial = this.progressBarRight;
          // console.log("Init1: " + this.progressBarRightInitial);
          this.animationIntervalRunning = false;
          clearInterval(this.animationInterval);
          // console.log("ANIMATION FINISHED");
          return;
        }
        // console.log("out0");

        let t = currentStep / 100;
        let p = this.spring_wobbly(t);
        this.progressBarRight =
          this.progressBarRightInitial +
          ((scaling / endwert) *
            (n * Math.round(this.lerp(0, 10 * anzahl, p) * 10000))) /
            10000;

        if (this.progressBarRight < 0) this.progressBarRight = 0;
        currentStep++;
      }, (duration * (1000 / anzahl)) / steps);
      // console.log("outOut0");
    },
    changeProgressBar(n, anzahl) {
      this.animateProgressBar(Math.sign(n), anzahl);
    },
    answerChange(answer) {
      console.log(this.answers);
      console.log(answer);
      for (var i = 0; i < this.answers.length; i++) {
        if (this.answers[i] == 0 && answer[i] != 0) {
          this.answers[i] = answer[i];
          this.addAnswer();
        } else if (this.answers[i] != 0 && answer[i] == 0) {
          this.answers[i] = 0;
          this.removeAnswer();
        } else if (this.answers[i] != answer[i]) {
          this.answers[i] = answer[i];
        }
      }
      console.log(this.answers);
      console.log(answer);
    },
    addAnswer() {
      console.log("ADDanswer");
      this.changeProgressBar(20);
      this.answers_given++;
      if (this.answers_given > 3) this.answers_given = 3;
    },
    removeAnswer() {
      console.log("REMOVEanswer");
      this.changeProgressBar(-20);
      this.answers_given--;
      if (this.answers_given < 0) this.answers_given = 0;
    },
    newState(neuerZustand) {
      let found = false;
      //zuerst alle false setzten
      for (const s in this.state) {
        if (s == neuerZustand) found = true;
        this.state[s] = false;
      }
      //check if unknown state
      if (!found) {
        console.log("unknown state: " + neuerZustand);
        return;
      }
      //set new state
      this.state[neuerZustand] = true;
      //reset the bar if initial
      if (neuerZustand == "initial") this.resetBar();
    },
    selectParticipant(n) {
      if (this.participantSelected == n) {
        this.participantSelected = "";
        this.changeProgressBar(-20);
        return;
      }
      if (this.userName == n) {
        this.setMessage("cannot give feedback to yourself");
        return;
      }

      if (!this.participantSelected) {
        this.changeProgressBar(20);
      }
      this.participantSelected = n;
    },
    selectQuestion(n) {
      if (this.questionSelected == n) {
        this.questionSelected = "";
        this.changeProgressBar(-20);
        return;
      }
      if (this.questionSelected == "") {
        //new question was selected
        this.changeProgressBar(20);
      }

      // if (!this.questionSelected) {
      //   this.changeProgressBar(20);
      // }
      this.questionSelected = n;
    },
    clickTopButton() {
      if (this.waitingFlag) return;
      //give feedback @ initial
      if (this.state.initial) {
        this.newState("selectParticipantAndQuestion");
        return;
      }

      if (this.state.selectParticipantAndQuestion) {
        if (this.participantSelected == "") {
          this.setMessage("no participant selected!");
          return;
        }
        if (this.questionSelected == "") {
          this.setMessage("no exercise selected!");
          return;
        }
        this.newState("selectAnswer");
        return;
      }

      if (this.state.selectAnswer) {
        console.log(this.answers_given);
        if (this.answers_given >= 3) {
          this.sendFeedback();
        } else {
          this.setMessage("missing answers");
        }
        return;
      }

      // if (this.state.review) {
      //   if (!(this.selectedForReview.u && this.selectedForReview.f)) {
      //     this.setMessage("please select feedback");
      //     return;
      //   }
      //   this.newState("reviewSingle");
      //   return;
      // }
    },
    calcScore(participants) {
      var me = null;
      for (const p in participants) {
        if (p == this.userName) {
          me = participants[p];
          break;
        }
      }
      if (!me) return 0;

      let count = 0;
      if (me.score == 0) return 0;

      for (const uebung in me) {
        if (uebung == "score" || uebung == "winner" || uebung == "nameAlt")
          continue;
        count += Object.keys(me[uebung]).length;
      }
      return Math.round((me.score / count) * 10) / 10;
    },
    sendFeedback() {
      this.waitingFlag = true;
      if (this.waitingFlagTimer) {
        clearTimeout(this.waitingFlagTimer);
      }
      this.waitingFlagTimer = setTimeout(() => {
        this.waitingFlag = false;
      }, 5000);

      this.$http
        .post("/sendFeedback", {
          token: this.token,
          answers: this.answers,
          toPlayer: this.participantSelected,
          question: this.questionSelected,
        })
        .then((res) => {
          console.log(res);
          if (res.status === 200) {
            this.setMessage(res.data.msg);
            if (res.data.type == "success") {
              this.waitingFlag = false;

              //reset to intial
              this.questionSelected = "";
              this.answers_given = 0;
              this.participantSelected = "";
              this.newState("initial");
              return true;
            }
          } else {
            this.waitingFlag = false;
            this.setMessage(
              "cannot connect to server, please check your connection or reload the page"
            );
            return false;
          }
        });
    },
    clickBottomButton() {
      if (this.state.selectParticipantAndQuestion) {
        //go back
        this.newState("initial");
        // this.$refs.Review.reset();

        if (this.participantSelected && this.questionSelected) {
          this.changeProgressBar(-20);
        } else if (this.participantSelected || this.questionSelected) {
          this.changeProgressBar(-20);
        }
        this.questionSelected = "";
        this.participantSelected = "";
        return;
      }
      if (this.state.selectAnswer) {
        //go back
        if (this.answers_given > 0) {
          // this.changeProgressBar(-20);
          this.changeProgressBar(-1, this.answers_given);
        }
        this.$refs.Questions.reset();
        this.answers_given = 0;
        this.answers = new Array(3).fill(0);
        this.newState("selectParticipantAndQuestion");
        return;
      }
      if (this.state.initial) {
        //user is at the beginning and wants to see his feedback
        this.newState("review");
        return;
      }
      if (this.state.review) {
        //go back
        this.selectedForReview = {};
        this.newState("initial");
        return;
      }

      if (this.state.reviewSingle) {
        //go back
        this.selectedForReview = {};
        this.newState("review");
        return;
      }
    },
    //
    //
    //
    //
    //
    setMessage(msg) {
      this.msg = msg;
      if (this.msgTimer) {
        clearTimeout(this.msgTimer);
      }
      this.msgTimer = setTimeout(() => {
        this.msg = "";
      }, 3000);
    },
    checkToken() {
      this.$http
        .post("/checkToken", {
          token: this.token,
          device: this.device,
        })
        .then((res) => {
          console.log(res);
          if (res.status === 200) {
            this.setMessage(res.data.msg);
            if (res.data.type == "success") {
              this.participants = res.data.room; //Grundstruktur
              this.questions = res.data.questions;
              // console.log(this.questions);
              this.userName = res.data.name;
              this.userNameAlt = res.data.nameAlt;

              this.createInterval();
              // console.log("token success");
              // console.log(this.participants);
              // console.log(this.userName);
              // console.log(this.participants[this.userName]);

              return true;
            } else {
              this.$router.push({
                name: "Error",
                params: { msg: res.data.msg },
              });
              // this.$router.push("/Error");
            }
          } else {
            this.setMessage(
              "cannot connect to server, please check your connection or reload the page"
            );
            // this.setMessage('error bei der Verbindung zum Server, versuchen sie es erneut, checken sie die Internetverbindung...')
            return false;
          }
        });
    },
    readRoom() {
      this.$http
        .post("/readRoom", {
          token: this.token, //damit wissen wir schon die credentials und den richtigen Raum
          currentEntry: this.currentEntry,
        })
        .then((res) => {
          // console.log(res);
          if (res.status === 200 && res.data.type == "success") {
            // console.log("success, readRoom");
            if (res.data.emptyRoom) {
              // console.log("no new Data");
              return true;
            }

            console.log("READING ROOM GOT NEW DATA");
            console.log(res.data.room);
            this.participants = res.data.room;
            this.currentEntry = res.data.currentEntry;

            if (this.participants[this.userName]) {
              if (
                this.participants[this.userName].winner &&
                this.participants[this.userName].winner == 1
              )
                this.createConfetti();
            }

            return true;
          }
          return false;
        });
    },
    createInterval() {
      setInterval(this.readRoom, 1000);
    },
    patricipantFilter(text) {
      return text.substr(1, 2);
    },
    numberFilter(n) {
      return parseFloat(n).toLocaleString("de-DE");
    },
    scoreFilter() {
      // console.log(this.score);
      if (this.score == 0) return "--,-";
      let s = this.numberFilter(this.score);
      if (!String(s).includes(",")) {
        return s + ",0";
      }
      return s;
    },
  },
  created() {
    let userAgent = window.navigator.userAgent;
    this.device = new DeviceDetector().parse(userAgent);
    // console.log(this.device);
    console.log("created");
    this.checkToken();
  },
  mounted() {},
};
</script>

<style scoped>
#me {
  position: absolute;
  top: 0px;
  left: 0px;
  color: #d2d2d2;
  font-size: 32px;
}

.aufUebung {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  top: -35px;
}

.trophy {
  position: absolute;
  width: 20%;
  right: 10px;
  top: 50px;
}

.abstand {
  height: 20px;
}

.reviewSubtitel {
  display: flex;
  justify-content: space-between;
}

#SubTitle {
  text-align: center;
  font-size: min(7vw, 41px);
  margin-top: 10px;
}

.subsmaller {
  font-size: 22px !important;
}

/* .questions {
  position: absolute;
  transform: translate(-50%, -55%);
  left: 50%;
  top: 50%;
} */

.questions {
  margin-top: 10px;
}

.borderRadiusRight {
  border-top-right-radius: 5px;
  border-bottom-right-radius: 5px;
}

.borderRadiusLeft {
  border-top-left-radius: 5px;
  border-bottom-left-radius: 5px;
}

#topHolder {
  overflow: hidden;
  position: relative;
  margin: 0 auto;
}
.giveFeedback {
  border: 2px solid var(--darkgreen);
  -webkit-transition: all 1s ease-out;
  -moz-transition: all 1s ease-out;
  -o-transition: all 1s ease-out;
  transition: all 1s ease-out;
  /* background: white; */
}

.giveFeedback:active {
  background-color: var(--doblhoferRed);
  border: 2px solid var(--doblhoferRed);
  color: white;
}

.feedbackBottom:active {
  background-color: var(--doblhoferRed);
  border: 2px solid var(--doblhoferRed);
  color: white;
}

.topColor {
  height: calc(100% - 14px);
  position: absolute;
  top: 7px;
  z-index: -1;
}

.moveAnimation {
  animation: 1s move linear;
}

#topColorWhite {
  background: var(--green);
  /* background: white; */
  width: 100%;
  right: 0px;
  /* animation: 1s move linear; */
  animation-fill-mode: both;
  border-radius: 5px;
}

#topColor {
  /* background: linear-gradient(to right, #00ffa9 0%, #5fff00 100%); */
  /* background: linear-gradient(to right, #49ab5b 0%, #2b6536 100%); */
  /* background: linear-gradient(to right, #2b6536 0%, #49ab5b 100%); */
  background: linear-gradient(to right, #8b1d44 0%, #c10b4b 100%);
  /* background: var(--doblhoferRed); */
  width: 100%;
  left: 50%;
  transform: translate(-50%, 0);
  border-radius: 5px;
}

#ParticipantHolder {
  /* background: red; */
  height: 45vh;
  overflow: scroll;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-around;
  margin: 0 auto;
}

.participant {
  margin: 6px;
  border: 2px solid var(--darkgreen);
  border-radius: 5px;
  /* width: 40px; */
  height: 40px;
  font-size: 30px;
  text-align: center;
  line-height: 43px;
  padding: 0 5px;
  color: var(--green);
}

.welcomeText {
  width: 100%;
  margin: 0 auto;
}

#middleText {
  text-align: center;
  font-size: 25px;
  width: min(100%, 650px);
  margin: 30px auto;
}

#score {
  text-align: center;
  font-size: min(18vw, 125px);
  -webkit-text-stroke-color: var(--green);
  color: white;
  -webkit-text-stroke-width: 2.4px;
}

.selected {
  background: var(--doblhoferRed) !important;
  border: 2px solid var(--doblhoferRed) !important;
  color: white;
}

#AtoD > button {
  width: min(50px, 6.5vh);
  height: min(50px, 6.5vh);
  font-size: min(43px, 5vh);
  border-radius: 10px;
  border: 2px solid var(--darkgreen);
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  background: var(--green);
  color: white;
  display: flex;
  justify-content: space-around;
}

#AtoD {
  position: absolute;
  display: flex;
  justify-content: space-between;
  width: min(calc(90% - 16px), 650px);
  bottom: 170px;
  left: 50%;
  transform: translate(-50%, 0%);
}

#Player {
  /* background: lime; */
  margin: 0 auto;
  max-width: 650px;
}

#feedbackHolder {
  position: absolute;
  width: min(89%, 650px);
  bottom: 8px;
  left: 50%;
  transform: translateX(-50%);
}
.feedback {
  font-size: min(10vw, 40px);
  width: 100%;
  margin: 7px auto;
  border-radius: 5px;
  text-align: center;
  padding: 2px;
  box-sizing: border-box;
  color: white;
}

.feedbackBottom {
  /* background: red; */
  background: var(--green);
  border: 2px solid var(--darkgreen);
}

.white {
  color: white;
}

#Title {
  text-align: center;
  font-size: min(11vw, 44px);
  color: var(--green);
  margin: 0 45px;
}

#messages {
  font-size: min(8vw, 35px);
  position: absolute;
  z-index: 3;
  background: var(--doblhoferRed);
  top: 0px;
  width: 100%;
  text-align: center;
  padding: 20px 0;
  left: 0px;
  color: white;
}

#version {
  position: fixed;
  right: 0px;
  bottom: 0px;
}

@media screen and (min-width: 500px) {
  #middleText {
    margin: 10px auto;
  }
}

@media screen and (min-width: 645px) {
  #middleText {
    margin: 30px auto;
  }
}

@media screen and (max-height: 720px) {
  #middleText {
    margin: 10px auto;
  }
}

@media screen and (max-height: 670px) {

  #SubTitle {
    margin: 0px;
  }
}

@media screen and (max-height: 620px) {
  #middleText {
    font-size: 17px;
  }
  #score {
    font-size: 50px;
  }
}

@media screen and (max-height: 588px) {
  #Title {
    font-size: 6vh;
  }
}

@media screen and (max-height: 640px) {
  .feedback {
    font-size: 30px;
    margin: 2px auto;
  }

  .topColor {
    height: calc(100% - 8px);
    top: 4px;
    margin-left: 1px;
  }

  #AtoD {
    bottom: 130px;
  }
}

@media screen and (max-height: 600px) {
  .participant {
    /* width: 28px; */
    height: 28px;
    font-size: 25px;
    line-height: 31px;
  }
}

@media screen and (max-height: 535px) {
  .questionText {
    font-size: 16px;
  }

  .questionAnswer[data-v-1d8df916] {
    width: 6vw;
    height: 6vw;
    line-height: 6vw;
    font-size: 5.3vw;
    box-shadow: 0px 0px 0px min(calc((11vw - min(7vw, 45px)) / 2 - 2px), 13px)
      white;
  }
}

.not_supported {
  display: none;
}

@media only screen and (max-width: 280px) {
  .not_supported {
    display: flex;
    position: fixed;
    justify-content: center;
    text-align: center;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 5;
    font-size: 30px;
    align-items: center;
    background: #fff;
    flex-wrap: wrap;
    flex-direction: column;
  }
}

@media screen and (max-height: 530px) {
  .participant {
    margin: 4px;
  }
  #ParticipantHolder {
    height: 37vh;
  }
}
</style>
